import React from 'react';
import styles from './RewardAlert.css';

const RewardAlert = ({ title, content }) => {
  return (
    <div className={`mt-5px ${styles.wrapper} ${styles.reward}`}>
      <div>
        <img
          src={require('assets/images/loyalty_reward.png')}
          className={`${styles.img}`}
        />
      </div>
      <div>
        <label className={`${styles.content}`}>
          <b>{`${title}`}</b>
          <br />
          {`${content}`}
        </label>
      </div>
    </div>
  );
};

export default RewardAlert;
